import * as EmailValidator from 'email-validator';

export const isValidEmail = (
  email: string | null | undefined
): boolean => {
  if (!email) {
    return false;
  }
  return EmailValidator.validate(email.trim());
};
